import { fetchOptions, handleResponse } from '@/common/apiCalls';
import Configs from '@/Configs';

/**
 * @param {string} publicId
 * @param {{ q?: string, page?: number, limit?: number }} [listParams]
 * @param {string|null} [correlationId]
 */
export async function getPublicCareersPage(publicId, listParams = {}, correlationId = null) {
  const params = new URLSearchParams();
  params.set('publicId', publicId);
  if (typeof listParams.q === 'string' && listParams.q.trim()) {
    params.set('q', listParams.q.trim());
  }
  if (listParams.page != null) {
    params.set('page', String(listParams.page));
  }
  if (listParams.limit != null) {
    params.set('limit', String(listParams.limit));
  }

  const response = await fetch(
    Configs.platformGetPublicCareersAPI + '?' + params.toString(),
    fetchOptions(
      'GET',
      null,
      import.meta.env.VITE_UNAUTHENTICATED_REQUESTS_API_TOKEN,
      'json',
      correlationId
    )
  );
  return handleResponse(response);
}

/**
 * @param {string} publicId
 * @param {string} jobID
 * @param {string|null} [correlationId]
 */
export async function getPublicCareersJob(publicId, jobID, correlationId = null) {
  const response = await fetch(
    Configs.platformGetPublicCareersJobAPI +
      '?publicId=' +
      encodeURIComponent(publicId) +
      '&jobID=' +
      encodeURIComponent(jobID),
    fetchOptions(
      'GET',
      null,
      import.meta.env.VITE_UNAUTHENTICATED_REQUESTS_API_TOKEN,
      'json',
      correlationId
    )
  );
  return handleResponse(response);
}

/**
 * @param {{
 *   publicId: string,
 *   jobID: string,
 *   firstName: string,
 *   lastName: string,
 *   email: string,
 *   linkedinUrl?: string,
 *   note?: string,
 * }} body
 * @param {string|null} [correlationId]
 */
export async function postPublicCareersApply(body, correlationId = null) {
  const response = await fetch(
    Configs.platformPostPublicCareersApplyAPI,
    fetchOptions(
      'POST',
      body,
      import.meta.env.VITE_UNAUTHENTICATED_REQUESTS_API_TOKEN,
      'json',
      correlationId
    )
  );
  return handleResponse(response);
}
